import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';

interface ReadOnlyBannerProps {
  reason?: 'excessive_upload' | 'manual_review' | 'payment_issue';
  flaggedAt?: Date;
}

export const ReadOnlyBanner: React.FC<ReadOnlyBannerProps> = ({
  reason = 'excessive_upload',
  flaggedAt,
}) => {
  const getMessage = () => {
    switch (reason) {
      case 'excessive_upload':
        return 'Your account is temporarily read-only while we review unusually high upload volume.';
      case 'manual_review':
        return 'Your account is under manual review and is currently read-only.';
      case 'payment_issue':
        return 'Your account is read-only due to a payment issue. Please update your payment method.';
      default:
        return 'Your account is temporarily read-only for security reasons.';
    }
  };

  const formatDate = (date?: Date) => {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  };

  return (
    <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">Account on Hold</h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{getMessage()}</p>
            {flaggedAt && (
              <p className="mt-1 flex items-center">
                <Clock className="h-4 w-4 mr-1" />
                Flagged on {formatDate(flaggedAt)}
              </p>
            )}
          </div>
          <div className="mt-3">
            <div className="-mx-2 -my-1.5 flex">
              <a
                href="mailto:support@autotaxpilot.com?subject=Account%20on%20Hold%20Inquiry"
                className="bg-red-50 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyBanner;
